export default __webpack_public_path__ + "static/media/logo-sm.a737e88d.png";